// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/src/asset/fonts/General-Sans/GeneralSans-Semibold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/src/asset/fonts/General-Sans/GeneralSans-Regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("/src/asset/fonts/General-Sans/GeneralSans-Medium.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("/src/asset/fonts/General-Sans/GeneralSans-Bold.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Semi Sans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  font-display: swap;
}
@font-face {
  font-family: "Regular Sans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
  font-display: swap;
}
@font-face {
  font-family: "Medium Sans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype");
  font-display: swap;
}
@font-face {
  font-family: "Bold Sans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype");
  font-display: swap;
}
.pagination-container {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.pagination-arrow-tile {
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.pagination-tile {
  display: flex;
  width: 40px;
  height: 40px;
  padding: 10px 0px;
  justify-content: center;
  align-items: center;
  color: var(--tertiary-text-color);
  /* 14 px Medium */
  font-family: "General-Sans";
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 140%; /* 19.6px */
  cursor: pointer;
}

.pagination-tile-active {
  display: flex;
  width: 40px;
  height: 40px;
  padding: 10px 0px;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: 4px;
  background: #5095fc;
  color: #fff;
  /* 14 px Medium */
  font-family: "General-Sans";
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 140%; /* 19.6px */
}

.pagiantion-icon {
  color: var(--tertiary-text-color);
}

.pagination-icon-disabled {
  color: var(--quartinary-surface-color);
}`, "",{"version":3,"sources":["webpack://./src/styles/fonts.scss","webpack://./src/@common/Pagination/pagination.scss"],"names":[],"mappings":"AAAA;EACE,wBAAA;EACA,4CAAA;EACA,+DAAA;EAEA,kBAAA;ACAF;ADGA;EACE,2BAAA;EACA,4CAAA;EACA,+DAAA;EAEA,kBAAA;ACFF;ADIA;EACE,0BAAA;EACA,4CAAA;EACA,+DAAA;EAEA,kBAAA;ACHF;ADKA;EACE,wBAAA;EACA,4CAAA;EACA,+DAAA;EAEA,kBAAA;ACJF;AArBA;EAGE,aAAA;EACA,2BAAA;EACA,mBAAA;AAqBF;;AAlBA;EAeE,WAAA;EACA,YAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AAOF;;AAJA;EACE,aAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,iCAAA;EACA,iBAAA;EACA,2BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;EACA,eAAA;AAOF;;AAJA;EACE,aAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,iBAAA;EACA,2BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;AAOF;;AALA;EACC,iCAAA;AAQD;;AANA;EACE,sCAAA;AASF","sourcesContent":["@font-face {\n  font-family: 'Semi Sans';\n  src: url('/src/asset/fonts/General-Sans/GeneralSans-Semibold.otf');\n  src: url('/src/asset/fonts/General-Sans/GeneralSans-Semibold.otf')\n    format('truetype');\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Regular Sans';\n  src: url('/src/asset/fonts/General-Sans/GeneralSans-Regular.otf');\n  src: url('/src/asset/fonts/General-Sans/GeneralSans-Regular.otf')\n    format('truetype');\n  font-display: swap;\n}\n@font-face {\n  font-family: 'Medium Sans';\n  src: url('/src/asset/fonts/General-Sans/GeneralSans-Medium.otf');\n  src: url('/src/asset/fonts/General-Sans/GeneralSans-Medium.otf')\n    format('truetype');\n  font-display: swap;\n}\n@font-face {\n  font-family: 'Bold Sans';\n  src: url('/src/asset/fonts/General-Sans/GeneralSans-Bold.otf');\n  src: url('/src/asset/fonts/General-Sans/GeneralSans-Bold.otf')\n    format('truetype');\n  font-display: swap;\n}\n","@import '../../styles/styles.scss';\n\n.pagination-container {\n  //   height: 10vh;\n  //   width: 50%;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.pagination-arrow-tile {\n  //   border: 1px solid #e1e6ee;\n  //   border-radius: 4px;\n  //   //   padding: 4px;\n  //   height: 30px;\n  //   width: 30px;\n  //   //   margin-left: 4px;\n  //   display: flex;\n  //   align-items: center;\n  //   justify-content: center;\n  //   cursor: pointer;\n  //   //   a: {\n  //   //     textDecoration: \"none\",\n  //   //     fontSize: [0, 0, 0, 0, 1],\n  //   //   },\n  width: 24px;\n  height: 24px;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n\n.pagination-tile {\n  display: flex;\n  width: 40px;\n  height: 40px;\n  padding: 10px 0px;\n  justify-content: center;\n  align-items: center;\n  color: var(--tertiary-text-color);\n  /* 14 px Medium */\n  font-family: 'General-Sans';\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 140%; /* 19.6px */\n  cursor: pointer;\n}\n\n.pagination-tile-active {\n  display: flex;\n  width: 40px;\n  height: 40px;\n  padding: 10px 0px;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  border-radius: 4px;\n  background: #5095fc;\n  color: #fff;\n  /* 14 px Medium */\n  font-family: 'General-Sans';\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 140%; /* 19.6px */\n}\n.pagiantion-icon {\n color: var(--tertiary-text-color);\n}\n.pagination-icon-disabled {\n  color: var(--quartinary-surface-color);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
